import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  // base:'./',//服务器访问的路径
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import( '../components/HelloWorld')
    },
    {
      path: '/pay',
      name: 'pay',
      component: () => import( '../components/Pay.vue'),
      children:[
        {
          path:'loading',
          component:()=> import('../components/loading.vue')
        }
      ]
      // 
    },
    {
      path: '/PaySuccess',
      name: 'paySuccess',
      component: () => import( '../components/PaySuccess.vue')
    },
    {
      path: '/alipyPayPage',
      name: 'alipyPayPage',
      component: () => import( '../components/alipyPayPage.vue'),
      // meta: {
      //       keepAlive: true  //判断是否缓存
      //      }
    },
    {
      path: '/alipayPaySucess',
      name: 'alipayPaySucess',
      component: () => import( '../components/alipayPaySucess.vue')
    },
    {
      path: '/payError',
      name: 'payError',
      component: () => import( '../components/payError.vue')
    }
  ],
  mode: 'history', // 去掉url中的#
  scrollBehavior(to, from, savedPosition) {
    return {
        x: 0,
        y: 0
    }
  }
})




// WEBPACK FOOTER //
// ./src/router/index.js